@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.root {
  display: block;
  border-radius: 50%;
  border-style: solid;
  border-color: transparent;
  mask:
    linear-gradient(#000, #000) padding-box,
    linear-gradient(#000, #000);
  mask-composite: exclude;
  animation: rotate 0.75s linear infinite reverse;
}

.small {
  border-width: 2px;
  inline-size: 1.125rem;
  block-size: 1.125rem;
}

.medium {
  border-width: 3px;
  inline-size: 2rem;
  block-size: 2rem;
}

.large {
  border-width: 4px;
  inline-size: 3rem;
  block-size: 3rem;
}

.primary {
  background:
    conic-gradient(var(--color__blue-400) 25%, transparent 25%) border-box,
    var(--color__blue-200) border-box;
}

.black {
  background:
    conic-gradient(var(--color__black) 25%, transparent 25%) border-box,
    oklch(from var(--color__black) l c h / 0.3) border-box;
}

.white {
  background:
    conic-gradient(var(--color__white) 25%, transparent 25%) border-box,
    oklch(from var(--color__white) l c h / 0.3) border-box;
}

.danger {
  background:
    conic-gradient(var(--color__red-500) 25%, transparent 25%) border-box,
    oklch(from var(--color__red-500) l c h / 0.3) border-box;
}
